<template>
	<el-tabs v-model="activeName">
    <el-tab-pane label="批量回退库存" name="multi">
      <div class="content-box">
        <edit-reserve-outbound type="pre"></edit-reserve-outbound>
      </div>
    </el-tab-pane>
    <el-tab-pane label="回退库存记录" name="his">
      <his v-if="activeName=='his'" :type="[20]"></his>
    </el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import EditReserveInbound from "@/views/Reserve/subs/EditReserveInbound.vue";
import His from "@/views/Reserve/subs/His.vue";
import EditReserveOutbound from "@/views/Reserve/subs/EditReserveOutbound.vue";

export default {
	mixins: [TabPage],
	components: {
    EditReserveOutbound,
    His,
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
